import LoginForm from "./_components/LoginForm";

function Login() {
  return (
    <div className="grid h-screen place-items-center bg-cool-gray-50">
      <LoginForm />
    </div>
  );
}

export default Login;
